import {
  Button,
  useBreakpointValue,
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import React from 'react';

const BackButton = (props: any) => {
  const isSmallScreen = useBreakpointValue({ base: true, sm: false });
  return (
    <Button
      mt={10}
      mb={3}
      w={isSmallScreen ? '100%' : 'min-content'}
      size="sm"
      leftIcon={<ArrowBackIcon />}
      {...props}
    />
  );
};

export default BackButton;
